/* Copyright (c) 2017 Backpack Health LLC */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AppHeaderScrollableText } from '../../../../components/appNav/AppHeaderScrollable';
import AppNavTopLevel from '../../../../components/appNav/AppNavTopLevel';
import TopLevelAddButton from '../../../presenters/TopLevelAddButton';
import ContentFrame from '../../../../applicationFrame/ContentFrame';
import AppNavPhrases from '../../../../../phraseKeys/AppNav.phrase';
import { ScrollAwareContext, ScrollAwareScroller } from '../../../../components/ScrollAware';
import ContentWrapper from '../../../../components/ContentWrapper';
import Card from '../../../../components/card/Card';
import { CollapsibleRow } from '../../../../components/card/CollapsibleRow';
import GroupSunset from '../../../../components/GroupSunset';

import GroupsList from '../GroupsList/GroupsList';
import { groupsZeroState } from '../../../../components/healthEntriesList/ZeroState';

import './MyGroups.styles.scss';

class MyGroups extends Component {

  UNSAFE_componentWillMount() {
    this.props.loadData(this.props.profileId);
  }

  renderActiveGroupsZeroState() {
    return (
      <Card
        className="mygroups-activegroups-zerostate font-color-gsMedDark font-subhead"
        hasDropshadow={false}
      >
        <FormattedMessage id="groups.previous.onlyPreviousGroups.message" />
      </Card>
    );
  }

  renderActiveGroups() {
    const { activeGroupIds, onSelectGroup } = this.props;

    if (activeGroupIds.length) {
      return (
        <GroupsList
          groupIds={activeGroupIds}
          onSelectGroup={onSelectGroup}
        />
      );
    }

    return this.renderActiveGroupsZeroState();
  }

  renderInactiveGroups() {
    const { inactiveGroupIds, onSelectGroup } = this.props;

    if (!inactiveGroupIds.length) return null;

    return (
      <Card className="bkgd-color-gsLight" hasDropshadow={false}>
        <CollapsibleRow
          title={(
            <div className="font-caption-1">
              <FormattedMessage id="groups.previous.previousGroupList.label" />
            </div>
          )}
          hasBorder
          topSectionClassName="border-color-gsMedDarkLT inactive-groups"
          isCollapsible
          defaultCollapsed
        >
          <GroupsList
            groupIds={inactiveGroupIds}
            onSelectGroup={onSelectGroup}
            hasRoundedWrapper={false}
            listItemClass="border-color-gsMedDarkLT"
          />
        </CollapsibleRow>
      </Card>
    );
  }

  renderContent() {
    const { activeGroupIds, inactiveGroupIds } = this.props;

    if (!activeGroupIds.length && !inactiveGroupIds.length) {
      return (
        <ContentWrapper isFlatContent={true}>
          {
            groupsZeroState(this.props.activeGroupIds.length)
          }
        </ContentWrapper>
      );
    }

    return (
      <ContentWrapper>
        <GroupSunset/>
        {this.renderActiveGroups()}
        {this.renderInactiveGroups()}
      </ContentWrapper>
    );
  }

  render() {
    const titleValues = AppNavPhrases.myGroups.title(this.props.isMainProfile, this.props.profile.greetingName());

    return (
      <div>
        <ScrollAwareContext>
          <AppNavTopLevel hasDropShadow />

          <ContentFrame className="bkgd-color-light-neutral">
            <ScrollAwareScroller>
              <AppHeaderScrollableText id={titleValues.id} values={titleValues.values} />
              {this.renderContent()}
            </ScrollAwareScroller>

            <TopLevelAddButton.MyGroup />

          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
MyGroups.propTypes = {
  profile: PropTypes.object,
  profileId: PropTypes.number,
  isMainProfile: PropTypes.bool,
  onGoToFindGroup: PropTypes.func,
  onSelectGroup: PropTypes.func,
  onGoBack: PropTypes.func,
  activeGroupIds: PropTypes.array,
  inactiveGroupIds: PropTypes.array,
  loadData: PropTypes.func,
};

export default MyGroups;
